import React, { useEffect, useState } from 'react';
import { supabase } from '../../utils/supabaseClient';

/**
 * AuthCallback component to handle authentication redirects
 * This component is used to handle redirects from Supabase authentication
 * such as email confirmations and password resets
 */
const AuthCallback = () => {
  const [message, setMessage] = useState('Processing authentication...');
  const [error, setError] = useState(null);

  useEffect(() => {
    // Get the hash fragment from the URL
    const hashFragment = window.location.hash;
    
    // Process the hash fragment if it exists
    if (hashFragment) {
      const handleHashChange = async () => {
        try {
          // Extract the access_token and refresh_token from the URL
          const params = new URLSearchParams(hashFragment.substring(1));
          const accessToken = params.get('access_token');
          const refreshToken = params.get('refresh_token');
          const type = params.get('type');
          
          if (accessToken && type === 'recovery') {
            // Handle password recovery
            setMessage('Password reset link detected. Please set a new password.');
            
            // You could redirect to a password reset form here
            // window.location.href = '/reset-password?token=' + accessToken;
          } else if (accessToken) {
            // Handle successful authentication
            const { error } = await supabase.auth.setSession({
              access_token: accessToken,
              refresh_token: refreshToken,
            });
            
            if (error) {
              throw error;
            }
            
            setMessage('Authentication successful! Redirecting...');
            
            // Redirect to the main application
            setTimeout(() => {
              window.location.href = '/';
            }, 2000);
          }
        } catch (err) {
          console.error('Error processing authentication:', err);
          setError('Authentication failed. Please try again.');
        }
      };
      
      handleHashChange();
    } else {
      // No hash fragment, check for query parameters (used in some auth flows)
      const queryParams = new URLSearchParams(window.location.search);
      const error = queryParams.get('error');
      const errorDescription = queryParams.get('error_description');
      
      if (error) {
        setError(`Authentication error: ${error}. ${errorDescription || ''}`);
      } else {
        setMessage('No authentication data found. Redirecting to home...');
        
        // Redirect to the main application after a delay
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      }
    }
  }, []);

  return (
    <div className="auth-callback">
      <h2>Authentication</h2>
      {error ? (
        <div className="error">{error}</div>
      ) : (
        <div className="message">{message}</div>
      )}
    </div>
  );
};

export default AuthCallback; 